import { useDispatch } from 'react-redux';
import { useEffect, useState, useMemo } from 'react';
import { companyApis } from '../store/apis/balanceApi';

function formatDateToYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const day = String(date.getDate()).padStart(2, '0'); 
    return `${year}-${month}-${day}`;
}

function getLastDayOfMonth(year, month) {
    return new Date(year, month + 1, 0);
}


function useMonthlyFinanceData(company, selectedYear) {
    const dispatch = useDispatch();
    
    const previousYear = selectedYear - 1;
    const [isFetching, setIsFetching] = useState(true);
    const [allData, setAllData] = useState([]);
    const [allBudgetData, setAllBudgetData] = useState([]);
        
    const dateRanges = useMemo(() => {
        const ranges = [];
        for (let i = 0; i < 12; i++) {
            ranges.push({
                from: formatDateToYYYYMMDD(new Date(selectedYear, i, 1, 0)),
                to: formatDateToYYYYMMDD(getLastDayOfMonth(selectedYear, i))
            });
            ranges.push({
                from: formatDateToYYYYMMDD(new Date(previousYear, i, 1, 0)),
                to: formatDateToYYYYMMDD(getLastDayOfMonth(previousYear, i))
            });

        }
        return ranges;
    }, [selectedYear, previousYear]);

    useEffect(() => {
        async function fetchData() {
            const balanceResults = [];
            const budgetResults = [];



            for (const range of dateRanges) {
                const yearForThisRange = new Date(range.from).getFullYear();
                const budgetGroup = "Budget"
                const financeAction = companyApis[company].endpoints.fetchBalance.initiate(range);
                const budgetAction = companyApis[company].endpoints.fetchBudget.initiate({
                    ...range,
                    budgetGroup
                });
                
                
                const financeResult = await dispatch(financeAction);
                const budgetResult = await dispatch(budgetAction);

                balanceResults.push({
                    month: range.from,
                    data: financeResult.data || financeResult.payload
                });

                budgetResults.push({
                    month: range.from,
                    data: budgetResult.data || budgetResult.payload
                });
            }

            setAllData(balanceResults);
            setAllBudgetData(budgetResults); 
            
            setIsFetching(false);
        }

        fetchData();
    }, [company, dateRanges, dispatch, selectedYear]);

    return { allData, allBudgetData, isFetching }; 
}


export default useMonthlyFinanceData;

